import React from 'react'
import PropTypes from 'prop-types'
import { AppliedTooltip as Tooltip, BaseSpan, PopoverContainer } from '../AppliedTooltip/AppliedTooltip'

const popoverTop = (
    <PopoverContainer title="Corporate phrase" color="#0095FF">
        Be careful with the use of jargon and corporate clichés, they can put
        off applicants
    </PopoverContainer>
)

class BullshitSpan extends React.Component {
    render() {
        return (
            <span>
                <Tooltip
                    popoverContent={popoverTop}
                    disabled={!this.props.user.userId}
                >
                    <BaseSpan 
                        offsetKey={this.props.offsetKey}
                        disabled={!this.props.user.userId}
                        color="#A1C1FF"
                        borderColor="#0095FF"
                    >
                        {this.props.children}
                    </BaseSpan>
                </Tooltip>
            </span>
        )
    }
}

BullshitSpan.propTypes = {
    children: PropTypes.array,
}

export default BullshitSpan
